module.exports = __webpack_public_path__ + "static/media/service2.aadbdf81.svg";